export default __webpack_public_path__ + "static/media/gift_tie.b90b0e53.jpg";